// eslint-disable-next-line import/named
import { schema } from 'normalizr'

export default abstract class RemoteModel {
  static schema: schema.Entity

  id!: string
}
